import styled from '@emotion/styled';
import { variants } from '../../text/Typography';
import { Variant } from '../../types/VariantTypes';

type LabelContainerProps = {
  labelColor: string;
  labelLifted?: boolean;
  variant?: Variant;
};
export const LabelContainer = styled.div`
  pointer-events: none;
  z-index: 1;
  ${variants.label.css}
  color: ${({ labelColor }: LabelContainerProps) => labelColor};
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: top left;
  transform: ${({ labelLifted }: LabelContainerProps) =>
    labelLifted ? 'translate(16px, 8px) scale(0.9)' : 'translate(16px, 23px) scale(1)'};
  font-weight: ${({ labelLifted, variant }: LabelContainerProps) =>
    labelLifted && variant !== 'dark' ? '500' : '400'};
  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
    transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`;
